import { Language, Market } from "@/constants";
import { User } from "./User";
import { Plan } from "./Plan";

enum RenewalFrequency {
  Month = "month",
  Year = "year",
  Custom = "custom",
}

export enum OrganizationStatus {
  AutomaticTrialExpired = "automatic_trial_expired",
}

export type Organization = {
  id?: string;
  name: string;
  uuid: string;
  status: OrganizationStatus;
  has_reached_num_alert_limit: boolean;
  languages: Language[];
  is_from_growth_app: boolean;
  users: User[];
  allow_sso_login_only: boolean;

  plan: Plan;
  country: Market;
  plan_subscriptions: {
    end_date: number;
    renewal_frequency: RenewalFrequency;
  }[];
};

export type OrganizationLight = Pick<
  Organization,
  "id" | "uuid" | "name" | "status"
>;
